import { jsdomReactUniDriver as jsdomReactLegacyUniDriver } from '@wix/unidriver-jsdom-react-legacy';
import { jsdomReactUniDriver as jsdomReactTestingLibraryReactUniDriver } from '@wix/unidriver-jsdom-react';
import { pupUniDriver } from '@wix/unidriver-puppeteer';

type UniDriverImplementation =
  | typeof jsdomReactLegacyUniDriver
  | typeof jsdomReactTestingLibraryReactUniDriver
  | typeof pupUniDriver;

export const uniDriverImplementation: { current: UniDriverImplementation } = {
  current: null,
};

export const setUniDriverImplementation = (
  implementation: UniDriverImplementation,
) => {
  uniDriverImplementation.current = implementation;
};

setUniDriverImplementation(pupUniDriver);
